import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { addBanner } from 'slice/bannerSlice';

const AddBanner = () => {
    const [formData, setFormData] = useState({
        title: '',
        heading: '',
        description: '',
        image: null,
    });

    const dispatch = useDispatch();
    const { loading } = useSelector((state) => state.banner);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'file' ? e.target.files[0] : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formDataToSend = new FormData();
        for (const key in formData) {
            formDataToSend.append(key, formData[key]);
        }

        try {
            dispatch(addBanner(formDataToSend));
            toast('Banner added successfully!');
            navigate('/khajuraho/banners');
            setFormData({
                title: '',
                heading: '',
                description: '',
                image: null,
            });
        } catch (error) {
            console.error('Error adding banner:', error.message);
        }
    };

    return (
        <div className='container-fluid mt-5'>
            <div className='mainheadig mx-4'>
                <h4 className='text-white font-weight-bold '>Add Banner</h4>
            </div>
            <form onSubmit={handleSubmit} className="bg-white p-4 mx-4 mt-5 rounded shadow">
                <div className='row'>
                    <div className='col-sm-12'>
                        <label className='adminlables'>
                            Small Title (e.g. UNESCO HERITAGE)
                            <input type='text' name='heading' value={formData.heading} className='form-control' onChange={handleChange} />
                        </label>
                    </div>
                    <div className='col-sm-12 mt-4'>
                        <label className='adminlables'>
                            Main Heading
                            <input type='text' name='title' value={formData.title} className='form-control' onChange={handleChange} />
                        </label>
                    </div>
                    <div className='col-sm-12 mt-4'>
                        <label className='adminlables'>
                            Description
                            <textarea name='description' value={formData.description} className='form-control' rows={3} onChange={handleChange}></textarea>
                        </label>
                    </div>
                    <div className='col-sm-12 mt-4'>
                        <label className='adminlables'>
                            Banner Image
                            <input type='file' name='image' className='form-control btn-block filebg' onChange={handleChange} required />
                        </label>
                    </div>
                </div>
                <div className='mt-5 text-right'>
                    <button className='btn btn-lg addbtn' disabled={loading}>{loading ? 'Adding...' : 'Add Banner'}</button>
                </div>
            </form>
        </div>
    );
};

export default AddBanner;
